import { SelectedFilterInterface } from "storyblok/components";
import React, { useEffect, useState } from "react";

import { ARROW_DOWN, CLOSE, Icon, SEARCH } from "components/ui";

import {
    Bold,
    Content,
    Description,
    FilterOption,
    FilterOptionsWrapper,
    Line,
    Reset,
    StyledButton,
    Wrapper
} from "./EmptyCard.styled";

import { filterOptionslabels } from "helpers/util/filterOptionsLabels";
import { useFilterOptions } from "helpers/hooks/useFilterOptions";
import { useMediaQueryContext } from "helpers/hooks";
import filterReset from "helpers/util/filterReset";
import filterTupleFilterer from "helpers/util/filterTupleFilterer";
import filterTupleMaker from "helpers/util/filterTupleMaker";

interface EmptyCardProps {
    loading?: boolean;
    calculatingFilters?: boolean;
    isZzp?: boolean;
}

export function EmptyCard({
    loading,
    calculatingFilters,
    isZzp
}: EmptyCardProps): JSX.Element {
    const { isTabletViewOrLarger } = useMediaQueryContext();
    const { filterOptions, setFilterOptions } = useFilterOptions();
    const [renderOptions, setRenderOptions] = useState<
        Array<Array<string | number>>
    >(filterTupleMaker(filterOptions));

    //useeffect needed to allow any change in filter to affect the alert component but not the other way around
    useEffect(() => {
        setRenderOptions(filterTupleMaker(filterOptions));
    }, [filterOptions, setFilterOptions]);

    //if still loading or calculating skip the rest
    if (loading || calculatingFilters) {
        return (
            <Wrapper>
                <Bold>Vacatures aan het zoeken...</Bold>
            </Wrapper>
        );
    } else {
        return (
            <Wrapper>
                {" "}
                <Icon
                    icon={SEARCH}
                    size={isTabletViewOrLarger ? 48 : 30}
                    viewbox="0 0 24 24"
                    color="var(--color-black)"
                    aria-hidden="true"
                />
                <Content>
                    <Bold>
                        Er zijn geen vacatures gevonden! Probeer je zoektermen
                        aan te passen of minder filters in te stellen.
                    </Bold>

                    <FilterOptionsWrapper>
                        {" "}
                        {!isZzp
                            ? renderOptions.map(([key, value], index) => {
                                  //if no special formatting needs to be done, simply render the value.
                                  return (
                                      <FilterOption
                                          key={`${key as string}-${index + 1}`}
                                          onClick={() =>
                                              setFilterOptions(
                                                  filterTupleFilterer(
                                                      key as keyof SelectedFilterInterface,
                                                      value,
                                                      filterOptions
                                                  )
                                              )
                                          }
                                      >
                                          {/* check if the value is from a category that needs specific formatting to be rendered and render accordingly */}
                                          {filterOptionslabels([
                                              key as string,
                                              value
                                          ])}
                                          <Icon icon={CLOSE} size={18} />
                                      </FilterOption>
                                  );
                              })
                            : // if zzp, only render the zzp hours filter
                              filterOptions.zzpHoursFilter.map(
                                  (value, index) => (
                                      <FilterOption key={`${value}-${index}`}>
                                          {`${value} uur`}
                                          <Icon icon={CLOSE} size={18} />
                                      </FilterOption>
                                  )
                              )}
                    </FilterOptionsWrapper>

                    <Reset onClick={() => setFilterOptions(filterReset())}>
                        Reset alle filters
                    </Reset>

                    {!isZzp && (
                        <>
                            <Line />
                            <Description>
                                Laat je gegevens achter en wij geven je een
                                seintje wanneer er een vacature is binnen jouw
                                wensen.
                            </Description>

                            <StyledButton
                                buttonType="secondary"
                                icon={ARROW_DOWN}
                                reversedOrder
                                role="presentation"
                                onClick={() => {
                                    if (typeof window !== "undefined") {
                                        const vacancyAlertElement =
                                            document.getElementById(
                                                "vacancyAlert"
                                            );
                                        vacancyAlertElement?.scrollIntoView({
                                            behavior: "smooth"
                                        });
                                    }
                                }}
                            >
                                Job alert instellen
                            </StyledButton>
                        </>
                    )}
                </Content>
            </Wrapper>
        );
    }
}
